import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

import { useI18n } from "../../languages/providers/I18nProvider";
import { useTheme } from "../../providers/ThemeContext";
import { AboutStyles } from "./AboutStyles";
import { aboutKeys } from "./AboutContent";
import banner2 from "../../assets/logo/creation-arts-branded-flags-outdoor.png";
import { GlobalStyles } from "../../styles/GlobalStyles";
import CallToAction from "../../components/common/CallToAction";
import { breadcrumbSchema } from "../../config/seoConfig";
import SEO from "../../components/common/SEO";
import { useLangPath } from "../../hooks/useLangPath";

const AboutPage = () => {
  const { theme } = useTheme();
  const { t, lang } = useI18n();

  const s = AboutStyles(theme);
  const globalStyles = GlobalStyles(theme);
  const lp = useLangPath();

  const isMobile = useMediaQuery("(max-width: 900px)");

  return (
    <>
      <SEO
        title={t("seo:about:title")}
        description={t("seo:about:description")}
        lang={lang}
        schema={[
          breadcrumbSchema(lang, [
            { name: t("nav:home"), path: "" },
            { name: t("nav:about"), path: "/about" },
          ]),
        ]}
      />
      <main style={globalStyles.page} id="topOfPage">
        {/* HERO (left) + banners (right) */}
        <section style={s.hero}>
          <div
            style={{ ...s.heroInner, ...(isMobile ? s.heroInnerMobile : {}) }}
          >
            <div style={s.heroText}>
              <span style={s.heroBadge}>{t("home:hero:badge")}</span>
              <h1
                style={{
                  ...globalStyles.pageTitle,
                  fontSize: "clamp(28px, 5vw, 44px)",
                }}
              >
                {t(aboutKeys.sections.storyTitle)}
              </h1>
              <p style={s.lead}>{t(aboutKeys.story.lead)}</p>
            </div>

            <div style={s.heroMedia}>
              <div style={s.bannerBox}>
                <img
                  src={banner2}
                  alt=""
                  style={isMobile ? s.bannerImgMobile : s.bannerImg}
                  loading="lazy"
                />
              </div>
            </div>

            <div style={s.heroCtasBox}>
              <div style={s.heroCtasRow}>
                <Link to={lp("/contact")} style={globalStyles.btnPrimary}>
                  {t(aboutKeys.hero.ctaPrimary)}
                </Link>
                <Link to={lp("/services")} style={globalStyles.btnSecondary}>
                  {t(aboutKeys.hero.ctaSecondary)}
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* STATS / statistics */}
        <section style={s.statsStrip}>
          {aboutKeys.stats.map((st) => (
            <div key={st.label} style={s.statCard}>
              <div style={s.statValue}>{st.value}</div>
              <div style={s.statLabel}>{t(st.label)}</div>
            </div>
          ))}
        </section>

        {/* VALUES */}
        <section style={globalStyles.section}>
          <h2 style={globalStyles.sectionTitle}>
            {t(aboutKeys.sections.valuesTitle)}
          </h2>
          <div style={s.grid3}>
            {aboutKeys.values.map((v) => (
              <article key={v.title} style={s.card}>
                <div style={globalStyles.featureTitle}>{t(v.title)}</div>
                <div style={globalStyles.featureText}>{t(v.text)}</div>
              </article>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section style={s.finalCta}>
          <CallToAction
            title={t(aboutKeys.sections.finalLead)}
            buttonLabel={t(aboutKeys.sections.finalBtn)}
          />
        </section>
      </main>
    </>
  );
};

export default AboutPage;
